var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3436 6.24893C11.3436 9.35985 8.8215 11.8821 5.71048 11.8821C2.59915 11.8821 0.0769348 9.35995 0.0769348 6.24893C0.0769348 3.1376 2.59905 0.615387 5.71048 0.615387C8.8214 0.615387 11.3436 3.1375 11.3436 6.24893Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3436 25.854C11.3436 28.965 8.82149 31.4872 5.71047 31.4872C2.59914 31.4872 0.0769196 28.9651 0.0769196 25.854C0.0769196 22.7427 2.59903 20.2209 5.71047 20.2209C8.82138 20.2209 11.3436 22.7427 11.3436 25.854Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9487 6.24893C30.9487 9.35985 28.4266 11.8821 25.3156 11.8821C22.2043 11.8821 19.6825 9.35995 19.6825 6.24893C19.6825 3.1376 22.2043 0.615387 25.3156 0.615387C28.4265 0.615387 30.9487 3.1375 30.9487 6.24893Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9487 25.854C30.9487 28.965 28.4266 31.4872 25.3156 31.4872C22.2043 31.4872 19.6825 28.9651 19.6825 25.854C19.6825 22.7427 22.2043 20.2209 25.3156 20.2209C28.4265 20.2209 30.9487 22.7427 30.9487 25.854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5cd5499d4996e4315539e6e8f4690fda.svg";
export { ForwardRef as ReactComponent };